<template>
	<div class="notes">
		<quill-editor class="ql-editor" ref="myTextEditor" v-model="content" :options="editorOption"
			@blur="onEditorBlur($event)" @focus="onEditorFocus($event)" @ready="onEditorReady($event)"
			@change="onEditorChange($event)">
		</quill-editor>
	</div>
</template>

<script>
	export default {
		props: {
			values: { //用于回显
				type: String,
				default: ''
			},
		},
		data() {
			return {
				content: null,
				editorOption: {
					modules: {
						// ImageExtend: {
						// 	loading: true, // 可选参数 是否显示上传进度和提示语
						// 	name: 'file', // 图片参数名
						// 	size: 3, // 可选参数 图片大小，单位为M，1M = 1024kb
						// 	action: constHelp['WEBAPIURL'] + 'blog/ArticleUpload', //服务器地址, 如果action为空，则采用base64插入图片
						// 	// response 为一个函数用来获取服务器返回的具体图片地址
						// 	// 例如服务器返回{code: 200; data:{ url: 'baidu.com'}}
						// 	// 则 return res.data.url
						// 	response: (res) => {
						// 		return res.data;
						// 	},
						// 	headers: (xhr) => {}, // 可选参数 设置请求头部
						// 	start: () => {}, // 可选参数 自定义开始上传触发事件
						// 	end: () => {}, // 可选参数 自定义上传结束触发的事件，无论成功或者失败
						// 	error: () => {}, // 可选参数 自定义网络错误触发的事件
						// 	change: (xhr, formData) => {} // 可选参数 选择图片触发，也可用来设置头部，但比headers多了一个参数，可设置formData
						// },
						toolbar: {
							// handlers: {
							// 	'image': function() {
							// 		QuillWatch.emit(this.quill.id)
							// 	}
							// },
							container: [
								["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
								["blockquote", "code-block"], // 引用  代码块
								[{
									header: 1
								}, {
									header: 2
								}], // 1、2 级标题
								[{
									list: "ordered"
								}, {
									list: "bullet"
								}], // 有序、无序列表
								[{
									script: "sub"
								}, {
									script: "super"
								}], // 上标/下标
								[{
									indent: "-1"
								}, {
									indent: "+1"
								}], // 缩进
								// [{'direction': 'rtl'}],                         // 文本方向
								[{
									size: ["small", false, "large", "huge"]
								}], // 字体大小
								[{
									header: [1, 2, 3, 4, 5, 6, false]
								}], // 标题
								[{
									color: []
								}, {
									background: []
								}], // 字体颜色、字体背景颜色
								[{
									font: []
								}], // 字体种类
								[{
									align: []
								}], // 对齐方式
								["clean"], // 清除文本格式
								["link", "image", "video"] // 链接、图片、视频
							], //工具菜单栏配置
						}
					},
					placeholder: '请填写您的公告内容', //提示
					readyOnly: false, //是否只读
					theme: 'snow', //主题 snow/bubble
					syntax: true, //语法检测
				}
			}
		},
		watch: { //监听回显的数据变化
			values: {
				handler(newVal, oldVal) {
					this.content = newVal;
				},
				immediate: true
			}
		},
		methods: {
			// 失去焦点
			onEditorBlur(editor) {},
			// 获得焦点
			onEditorFocus(editor) {},
			// 开始
			onEditorReady(editor) {},
			// 值发生变化
			onEditorChange(editor) {
				this.content = editor.html;
				this.$emit('update:values', this.content);
			},
			getVal() { //返回内容
				return this.content;
			},
		},
		computed: {
			editor() {
				return this.$refs.myTextEditor.quillEditor;
			}
		},
		mounted() {

		}
	}
</script>

<style lang="less">
	 .notes{
		.quill-editor {
			padding: 0px !important;
			display: flex;
			flex-direction: column;
		}
		
		.ql-container {
			height: 300px;
		}

		.ql-snow .ql-tooltip[data-mode=link]::before {
			content: "请输入链接地址:";
		}

		.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
			border-right: 0px;
			content: '保存';
			padding-right: 0px;
		}

		.ql-snow .ql-tooltip[data-mode=video]::before {
			content: "请输入视频地址:";
		}

		.ql-snow .ql-picker.ql-size .ql-picker-label::before,
		.ql-snow .ql-picker.ql-size .ql-picker-item::before {
			content: '14px';
		}

		.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
		.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
			content: '10px';
		}

		.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
		.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
			content: '18px';
		}

		.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
		.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
			content: '32px';
		}

		.ql-snow .ql-picker.ql-header .ql-picker-label::before,
		.ql-snow .ql-picker.ql-header .ql-picker-item::before {
			content: '文本';
		}

		.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
		.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
			content: '标题1';
		}

		.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
		.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
			content: '标题2';
		}

		.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
		.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
			content: '标题3';
		}

		.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
		.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
			content: '标题4';
		}

		.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
		.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
			content: '标题5';
		}

		.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
		.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
			content: '标题6';
		}

		.ql-snow .ql-picker.ql-font .ql-picker-label::before,
		.ql-snow .ql-picker.ql-font .ql-picker-item::before {
			content: '标准字体';
		}

		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
			content: '衬线字体';
		}

		.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
		.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
			content: '等宽字体';
		}
	}
</style>



// WEBPACK FOOTER //
// src/common/richText.vue